module.exports = __webpack_public_path__ + "img/rei_subespecialidades.2b75a466.png";